<template>
  <OutlinedIcon @click="$emit('input', !value)" v-if="getFlag('cohorts-show-pinned')">
    <v-icon :color="value ? 'black' : '#b0b3b6'" small>mdi-pin</v-icon>
  </OutlinedIcon>
</template>

<script>
import OutlinedIcon from './OutlinedIcon.vue'
export default {
  components: { OutlinedIcon },
  props: ['value'],
}
</script>

<style lang="scss" scoped>
i {
  margin: 4px;
  transform: rotate(45deg);
}
</style>